/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Searchheader_Showingresultsfor3Inputs */

const id_components_searchheader_showingresultsfor3 = /** @type {(inputs: Components_Searchheader_Showingresultsfor3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menampilkan hasil untuk`)
};

const ms_components_searchheader_showingresultsfor3 = /** @type {(inputs: Components_Searchheader_Showingresultsfor3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menunjukkan hasil untuk`)
};

const da_components_searchheader_showingresultsfor3 = /** @type {(inputs: Components_Searchheader_Showingresultsfor3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viser resultater for`)
};

const de_components_searchheader_showingresultsfor3 = /** @type {(inputs: Components_Searchheader_Showingresultsfor3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeige Ergebnisse für`)
};

const en_us2_components_searchheader_showingresultsfor3 = /** @type {(inputs: Components_Searchheader_Showingresultsfor3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Showing results for`)
};

const es_es2_components_searchheader_showingresultsfor3 = /** @type {(inputs: Components_Searchheader_Showingresultsfor3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrando resultados para`)
};

const es_mx2_components_searchheader_showingresultsfor3 = /** @type {(inputs: Components_Searchheader_Showingresultsfor3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrando resultados para`)
};

const fil_components_searchheader_showingresultsfor3 = /** @type {(inputs: Components_Searchheader_Showingresultsfor3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ipinapakita ang mga resulta para sa`)
};

const fr_components_searchheader_showingresultsfor3 = /** @type {(inputs: Components_Searchheader_Showingresultsfor3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Résultats pour`)
};

const it_components_searchheader_showingresultsfor3 = /** @type {(inputs: Components_Searchheader_Showingresultsfor3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostra risultati per`)
};

const hu_components_searchheader_showingresultsfor3 = /** @type {(inputs: Components_Searchheader_Showingresultsfor3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Találatok a következőre:`)
};

const nl_components_searchheader_showingresultsfor3 = /** @type {(inputs: Components_Searchheader_Showingresultsfor3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resultaten weergeven voor`)
};

const no_components_searchheader_showingresultsfor3 = /** @type {(inputs: Components_Searchheader_Showingresultsfor3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viser resultater for`)
};

const pl_components_searchheader_showingresultsfor3 = /** @type {(inputs: Components_Searchheader_Showingresultsfor3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wyświetlanie wyników dla`)
};

const pt_br2_components_searchheader_showingresultsfor3 = /** @type {(inputs: Components_Searchheader_Showingresultsfor3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Showing results for`)
};

const pt_components_searchheader_showingresultsfor3 = /** @type {(inputs: Components_Searchheader_Showingresultsfor3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A mostrar resultados para`)
};

const ro_components_searchheader_showingresultsfor3 = /** @type {(inputs: Components_Searchheader_Showingresultsfor3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se afișează rezultate pentru`)
};

const fi_components_searchheader_showingresultsfor3 = /** @type {(inputs: Components_Searchheader_Showingresultsfor3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Näytetään tulokset haulle`)
};

const sv_components_searchheader_showingresultsfor3 = /** @type {(inputs: Components_Searchheader_Showingresultsfor3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visar resultat för`)
};

const vi_components_searchheader_showingresultsfor3 = /** @type {(inputs: Components_Searchheader_Showingresultsfor3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hiển thị kết quả cho`)
};

const tr_components_searchheader_showingresultsfor3 = /** @type {(inputs: Components_Searchheader_Showingresultsfor3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Şunun için sonuçlar gösteriliyor:`)
};

const cs_components_searchheader_showingresultsfor3 = /** @type {(inputs: Components_Searchheader_Showingresultsfor3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zobrazují se výsledky pro`)
};

const bg_components_searchheader_showingresultsfor3 = /** @type {(inputs: Components_Searchheader_Showingresultsfor3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Показване на резултати за`)
};

const ru_components_searchheader_showingresultsfor3 = /** @type {(inputs: Components_Searchheader_Showingresultsfor3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Показаны результаты для`)
};

const uk_components_searchheader_showingresultsfor3 = /** @type {(inputs: Components_Searchheader_Showingresultsfor3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Результати для`)
};

const ar_components_searchheader_showingresultsfor3 = /** @type {(inputs: Components_Searchheader_Showingresultsfor3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عرض نتائج`)
};

const hi_components_searchheader_showingresultsfor3 = /** @type {(inputs: Components_Searchheader_Showingresultsfor3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`परिणाम दिखा रहा है`)
};

const th_components_searchheader_showingresultsfor3 = /** @type {(inputs: Components_Searchheader_Showingresultsfor3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กำลังแสดงผลลัพธ์สำหรับ`)
};

const ja_components_searchheader_showingresultsfor3 = /** @type {(inputs: Components_Searchheader_Showingresultsfor3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`結果を表示中：`)
};

const zh_cn2_components_searchheader_showingresultsfor3 = /** @type {(inputs: Components_Searchheader_Showingresultsfor3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Showing results for`)
};

const zh_hant1_components_searchheader_showingresultsfor3 = /** @type {(inputs: Components_Searchheader_Showingresultsfor3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Showing results for`)
};

const ko_components_searchheader_showingresultsfor3 = /** @type {(inputs: Components_Searchheader_Showingresultsfor3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Showing results for`)
};

/**
* | output |
* | --- |
* | "Showing results for" |
*
* @param {Components_Searchheader_Showingresultsfor3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_searchheader_showingresultsfor3 = /** @type {((inputs?: Components_Searchheader_Showingresultsfor3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Searchheader_Showingresultsfor3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_searchheader_showingresultsfor3(inputs)
	if (locale === "ms") return ms_components_searchheader_showingresultsfor3(inputs)
	if (locale === "da") return da_components_searchheader_showingresultsfor3(inputs)
	if (locale === "de") return de_components_searchheader_showingresultsfor3(inputs)
	if (locale === "en-US") return en_us2_components_searchheader_showingresultsfor3(inputs)
	if (locale === "es-ES") return es_es2_components_searchheader_showingresultsfor3(inputs)
	if (locale === "es-MX") return es_mx2_components_searchheader_showingresultsfor3(inputs)
	if (locale === "fil") return fil_components_searchheader_showingresultsfor3(inputs)
	if (locale === "fr") return fr_components_searchheader_showingresultsfor3(inputs)
	if (locale === "it") return it_components_searchheader_showingresultsfor3(inputs)
	if (locale === "hu") return hu_components_searchheader_showingresultsfor3(inputs)
	if (locale === "nl") return nl_components_searchheader_showingresultsfor3(inputs)
	if (locale === "no") return no_components_searchheader_showingresultsfor3(inputs)
	if (locale === "pl") return pl_components_searchheader_showingresultsfor3(inputs)
	if (locale === "pt-BR") return pt_br2_components_searchheader_showingresultsfor3(inputs)
	if (locale === "pt") return pt_components_searchheader_showingresultsfor3(inputs)
	if (locale === "ro") return ro_components_searchheader_showingresultsfor3(inputs)
	if (locale === "fi") return fi_components_searchheader_showingresultsfor3(inputs)
	if (locale === "sv") return sv_components_searchheader_showingresultsfor3(inputs)
	if (locale === "vi") return vi_components_searchheader_showingresultsfor3(inputs)
	if (locale === "tr") return tr_components_searchheader_showingresultsfor3(inputs)
	if (locale === "cs") return cs_components_searchheader_showingresultsfor3(inputs)
	if (locale === "bg") return bg_components_searchheader_showingresultsfor3(inputs)
	if (locale === "ru") return ru_components_searchheader_showingresultsfor3(inputs)
	if (locale === "uk") return uk_components_searchheader_showingresultsfor3(inputs)
	if (locale === "ar") return ar_components_searchheader_showingresultsfor3(inputs)
	if (locale === "hi") return hi_components_searchheader_showingresultsfor3(inputs)
	if (locale === "th") return th_components_searchheader_showingresultsfor3(inputs)
	if (locale === "ja") return ja_components_searchheader_showingresultsfor3(inputs)
	if (locale === "zh-CN") return zh_cn2_components_searchheader_showingresultsfor3(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_searchheader_showingresultsfor3(inputs)
	return ko_components_searchheader_showingresultsfor3(inputs)
});
export { components_searchheader_showingresultsfor3 as "components.searchHeader.showingResultsFor" }